import GenericNavigation from "./GenericNavigation.js";

const DayNavigation = ({ liveDates, activeDate, setActiveDate }) => {
  
    return (
      <GenericNavigation liveDates={liveDates} activeDate={activeDate?.toString()} setActiveDate={setActiveDate} itemRenderer={(date) => `Journée ${date}`}/>
    );
};

export default DayNavigation